import { useState, useRef, useEffect, useMemo } from 'react'
import { inject, observer } from 'mobx-react';
import { createMultipleRef } from '../../helpers'
import { Card, Button, ModalAlert, Select, FormLoading } from '../../components'
import { CommonService, DeliveryCostService } from "../../services";
import DataGrid, { SearchPanel, Scrolling, Paging, Pager, Column } from 'devextreme-react/data-grid';
import { SearchIcon } from '@heroicons/react/outline';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment'
import { BASE_URL } from '../../AppConfig'
import { DownloadIcon, UploadIcon } from '@heroicons/react/solid';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';
let firstRender = false
const FleetCard = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['expenses', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const inputUploadRef: any = useRef(null);
  const [fileUploadName, setFileUploadName] = useState("")
  const [masterOptions, setMasterOptions] = useState({ vehicle: [] })
  const [loading, setLoading]: any = useState({ visible: false, tip: 'saving' })
  const [dataSource, setDataSource]: any = useState([])
  const [filterCurrent, setFilterCurrent]: any = useState({})
  const [filter, setFilter]: any = useState({
    sdate: moment().format("YYYY-MM-DD"),
    edate: moment().format("YYYY-MM-DD"),
    vid: "",
    status: ""
  })
  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: ""
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: [],

    }
  })

  const [dataForm, setDataForm]: any = useState({
    "dlv_doc_no": "",
    "route_id": "",
    "ts_gate_in": "",
    "ts_gate_out": "",
    "mileage_start": "",
    "mileage_end": "",
    "service_info": "",
    "tasks": [],
    "cost_items": []
  })

  const gridRef: any = useRef(null);
  const inputRef: any = useRef([]);
  createMultipleRef(inputRef, 2)

  let columns = [
    {
      dataField: 'trans_date',
      caption: "DATE",
      allowFiltering: false,
      fixed: true
    },
    {
      dataField: 'trans_id',
      caption: "TRANSACTION_ID",
      allowFiltering: true,
      allowSearch: true,
      fixed: true
    },
    {
      dataField: 'driver_name',
      caption: "DRIVER_NAME"
    },
    {
      dataField: 'licenseplate',
      caption: "LICENSE_PLATE_NO"
    },
    {
      dataField: 'mileage',
      caption: "MILEAGE"
    },
    {
      dataField: 'ref_cost',
      caption: "REF_COST_CENTER"
    },
    {
      dataField: 'pont_val',
      caption: "POINT"
    },
    {
      dataField: 'point_extra',
      caption: "POINT_EXTRA"
    },
    {
      dataField: 'card_no',
      caption: "CARD_NO"
    },
    {
      dataField: 'cust_name',
      caption: "CUSTOMER_NAME"
    },
    {
      dataField: 'branch_name',
      caption: "BRANCH_NAME"
    },
    {
      dataField: 'business_type',
      caption: "BUSINESS_TYPE"
    },
    {
      dataField: 'product_type',
      caption: "PRODUCT_TYPE"
    },
    {
      dataField: 'unit_price',
      caption: "UNIT_PRICE"
    },
    {
      dataField: 'litre',
      caption: "LITRE"
    },
    {
      dataField: 'amount',
      caption: "AMOUNT"
    },
    {
      dataField: 'status',
      caption: "STATUS"
    },
    {
      dataField: 'tax_inv',
      caption: "เลขที่ใบกำกับ"
    },
    {
      dataField: 'remark_cust',
      caption: "REMARK (CUSTOMER)"
    },
    {
      dataField: 'remark_void',
      caption: "REMARK (VOIDID)"
    },
    {
      dataField: 'trxdate',
      caption: "วันที่ทำรายการ"
    },
    {
      dataField: 'doc_no',
      caption: "เลขที่เอกสาร"
    }
  ]

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "vehicle")
        .then((res: any) => {
          let vehicle = res.result.vehicle.map((item) => ({ label: item.licenseplate, value: item.vehicle_id }))
          setMasterOptions({ ...masterOptions, vehicle })
        })
        .catch((err) => {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, content: `Load master data : ${err}` }
          })
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  //#region 

  const searchFlclist = (isReloadCurrent = false, reloadByRouteID = "") => {
    setLoading({ ...loading, visible: true, tip: 'loading' })
    setFilterCurrent(filter)
    let data = isReloadCurrent ? filterCurrent : filter
    DeliveryCostService.getFlclist(auth, data)
      .then((res: any) => {
        let { code, message, result, sys_message } = res
        if (code === 200) {
          setDataSource(result)
          if (reloadByRouteID !== "") {
            let data = result.find((item) => item.route_id === reloadByRouteID)
            if (data) setDataForm(data)
          }
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        setLoading({ ...loading, visible: false })
      })
      .catch((err) => {
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
        setLoading({ ...loading, visible: false })
      })
  }

  const handleFileChange = (e) => {
    if (!e.target.files) return;

    setLoading({ ...loading, visible: true, tip: 'กำลังอัปโหลด...' })
    let isError = false
    const fileLists = Array.from(e.target?.files)
    fileLists.map((file: any) => {
      let nameSplite = file.name.split('.')
      let fileType = nameSplite[(nameSplite.length - 1)]

      setFileUploadName(file.name)
      if (fileType !== "xlsx") {
      }
    })

    if (!isError) {
      const data = new FormData();
      fileLists.forEach((file: any, i) => {
        data.append('files', file, file.name);
      });
      fetch(`${BASE_URL}/dlv_cost/upload_fleet_card`, {
        method: 'POST',
        headers: {
          'token_id': auth?.token_id,
          'action_user_id': auth?.action_user_id
        },
        body: data,
      })
        .then((res) => res.json())
        .then((data) => {
          let { code, message, sys_message } = data
          if (code === 200) {
            setOptionAlert({
              ...optionAlert,
              type: "success",
              show: true,
              action: {
                id: "",
                name: ""
              },
              title: "อัปโหลดสำเร็จ",
              description: { visible: false, type: "text", content: " ", contentLists: [] }
            })
          }
          else {
            setOptionAlert({
              ...optionAlert,
              type: "danger",
              show: true,
              action: {
                id: "",
                name: ""
              },
              title: "อัปโหลดผิดพลาด",
              description: { visible: true, type: "text", content: `${message} ${sys_message}` }
            })
          }
          setLoading({ ...loading, visible: false })
        })
        .catch((err) => {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "อัปโหลดผิดพลาด",
            description: { visible: true, type: "text", content: `${err}` }
          })
          setLoading({ ...loading, visible: false })
        })
    }
    else {
      setLoading({ ...loading, visible: false })
    }
  }

  let dateValue: any = [dayjs(filter.sdate, dateFormat), dayjs(filter.edate, dateFormat)]
  const isMobile = useMemo(() => window.innerWidth <= 768, []);
  //#endregion
  return (
    <div className="space-y-3 p-4">
      <Card title={t('fleet_card')}>
        <FormLoading loading={loading.visible} >
          <div className="flex flex-col lg:flex-row mb-2">

            <div className="flex flex-col lg:flex-row gap-2 w-full">

              {/* วันที่ */}
              <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                <label className="text-sm font-medium text-gray-700 sm:mt-3 sm:mr-2 text-start whitespace-nowrap">
                  {t('date')} :
                </label>
                <div className="mt-1 sm:mt-0 w-full">
                  <RangePicker
                    allowClear={false}
                    defaultValue={dateValue}
                    className="w-full sm:w-auto"
                    onChange={(d: any) => {
                      if (d) {
                        setFilter({
                          ...filter,
                          sdate: d[0].format("YYYY-MM-DD"),
                          edate: d[1].format("YYYY-MM-DD")
                        })
                      }
                      else {
                        setFilter({
                          ...filter,
                          sdate: "",
                          edate: ""
                        })
                      }
                    }}
                  />
                </div>
              </div>

              {/* ทะเบียน */}
              <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                <label className="text-sm font-medium text-gray-700 sm:mt-3 sm:mr-2 text-start whitespace-nowrap">
                  ทะเบียน :
                </label>
                <div className="mt-1 sm:mt-0 w-full">
                  <Select
                    allowClear={true}
                    showSearch={true}
                    defaultValue={filter.vid}
                    placeholder="ทะเบียน"
                    width={isMobile ? '100%' : 150}
                    options={masterOptions.vehicle}
                    onChange={(value) => setFilter({ ...filter, vid: value })}
                  />
                </div>
              </div>

              {/* ปุ่มค้นหา */}
              <div className="flex flex-col sm:flex-row sm:items-center">
                <label className="text-sm font-medium text-gray-700 sm:mt-3 sm:mr-2 text-start"></label>
                <div className="mt-1 sm:mt-0 pt-1 w-full">
                  <Button
                    text={t('search')}
                    icon={<SearchIcon />}
                    size="md"
                    type="white"
                    title={t('search')}
                    className="w-full sm:w-auto"
                    onClick={() => {
                      if (!loading.visible) {
                        searchFlclist()
                      }
                    }}
                  />
                </div>
              </div>

              {/* Upload */}
              <div className="flex flex-col sm:flex-row sm:items-center w-full sm:w-auto">
                <label className="text-sm font-medium text-gray-700 sm:mt-3 sm:mr-2 text-start"></label>
                <div className="mt-1 sm:mt-0 pt-1 w-full">
                  <input
                    className='hidden'
                    type="file"
                    ref={inputUploadRef}
                    onChange={handleFileChange}
                  />
                  <Button
                    text="อัปโหลด"
                    icon={<UploadIcon />}
                    size="md"
                    type="primary"
                    width="w-full"
                    iconPosition='start'
                    className="w-full sm:w-auto"
                    onClick={() => {
                      inputUploadRef.current.click()
                    }}
                  />
                </div>
              </div>

              {/* Excel */}
              <div className="flex flex-col sm:flex-row sm:items-center w-full sm:w-auto">
                <label className="text-sm font-medium text-gray-700 sm:mt-3 sm:mr-2 text-start"></label>
                <div className="mt-1 sm:mt-0 pt-1 w-full">
                  <Button
                    text="Excel"
                    icon={<DownloadIcon />}
                    size="md"
                    type="success"
                    width="w-full"
                    iconPosition='start'
                    className="w-full sm:w-auto"
                    onClick={() =>
                      window.open(`https://prod-coldchain-public.s3.ap-southeast-1.amazonaws.com/fleetcard/fleet_card_template.xlsx`)
                    }
                  />
                </div>
              </div>

            </div>
          </div>


          <DataGrid
            ref={(ref) => gridRef.current = ref}
            dataSource={dataSource}
            keyExpr={'no'}
            allowColumnReordering={true}
            hoverStateEnabled={true}
            columnAutoWidth={true}
            showBorders={true}
          >
            <Scrolling columnRenderingMode="virtual" />
            <SearchPanel visible={false} />
            <Paging defaultPageSize={10} />
            <Pager
              showInfo={true}
              showPageSizeSelector={true}
              allowedPageSizes={[10, 20, 50]}
            />
            {
              columns.map((column) => <Column
                key={column.dataField}
                fixed={column.fixed}
                allowSearch={column.allowSearch}
                allowFiltering={column?.allowFiltering || false}
                dataField={column.dataField}
                caption={column.caption}
              >
              </Column>)
            }
          </DataGrid>
        </FormLoading>
      </Card >

      <ModalAlert
        {...optionAlert}
        onOk={() => {
          setOptionAlert({ ...optionAlert, show: false })
        }}
        onCancel={() => {
          setOptionAlert({ ...optionAlert, show: false })
        }}
      />
    </div>
  )
}))

export default FleetCard